import type { NavItem } from "../../types";
import { legalNav, pressLinks, site, socialLinks } from "../../data";
import { Container } from "../ui/Container";
import { SocialLinks } from "../ui/SocialLinks";
import "./Footer.css";
import { siteUrl } from "../../wordpress";

/** Rodapé em cinco colunas: contacte, distribució, premsa, xarxes e legal. */
export function Footer() {
	return (
		<footer className="footer" id="contacte">
			<Container>
				<div className="footer__grid">
					<section className="footer__column">
						<h2>
							<a href={siteUrl("/contacte/")}>Contacte</a>
						</h2>
						<ul className="footer__list">
							<li className="footer__row">
								<PinIcon />
								<span>
									{site.address.city}, {site.address.zip}
								</span>
							</li>
							<li className="footer__row">
								<SendIcon />
								<a href={`mailto:${site.email}`}>{site.email}</a>
							</li>
						</ul>
					</section>

					<section className="footer__column">
						<h2>Distribució</h2>
						<p className="footer__strong">{site.distributor.name}</p>
						<p className="footer__text">{site.distributor.address}</p>
						<p className="footer__row">
							<PhoneIcon />
							<a href={`tel:${site.distributor.phone.replace(/\s/g, "")}`}>
								{site.distributor.phone}
							</a>
						</p>
					</section>

					<FooterLinks title="Premsa" items={pressLinks} />

					<section className="footer__column">
						<h2>Xarxes</h2>
						<SocialLinks links={socialLinks} />
					</section>

					<FooterLinks title="Pàgines legals" items={legalNav} />
				</div>
			</Container>
		</footer>
	);
}

function FooterLinks({ title, items }: { title: string; items: NavItem[] }) {
	return (
		<section className="footer__column">
			<h2>{title}</h2>
			<ul className="footer__list">
				{items.map((item) => (
					<li key={item.label}>
						<a
								href={siteUrl(item.href)}
							target={item.external ? "_blank" : undefined}
							rel={item.external ? "noreferrer" : undefined}
						>
							{item.label}
						</a>
					</li>
				))}
			</ul>
		</section>
	);
}

const iconProps = {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": true,
	focusable: false,
	className: "footer__icon",
} as const;

function PinIcon() {
	return (
		<svg {...iconProps}>
			<path d="M12 21.5s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" />
			<circle cx="12" cy="10.2" r="2.6" />
		</svg>
	);
}

function SendIcon() {
	return (
		<svg {...iconProps}>
			<path d="M21 3 3 10.4l7.3 2.9L13.2 21 21 3Z" />
			<path d="m10.3 13.3 4.2-4.2" />
		</svg>
	);
}

function PhoneIcon() {
	return (
		<svg {...iconProps}>
			<path d="M7.2 3.5h-2A2.2 2.2 0 0 0 3 5.9C3 13.9 10.1 21 18.1 21a2.2 2.2 0 0 0 2.4-2.2v-2l-4.3-1.7-2 2.3a14.4 14.4 0 0 1-5.6-5.6l2.3-2L9.2 5.5Z" />
		</svg>
	);
}
